'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactLifecyclesCompat = require('react-lifecycles-compat');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ExpandableList = require('./ExpandableList');

var _ExpandableList2 = _interopRequireDefault(_ExpandableList);

var _List = require('./List');

var _List2 = _interopRequireDefault(_List);

var _TextInputLabel = require('./TextInputLabel');

var _TextInputLabel2 = _interopRequireDefault(_TextInputLabel);

var _Ellipsis = require('./Ellipsis');

var _Ellipsis2 = _interopRequireDefault(_Ellipsis);

var _Divider = require('./Divider');

var _Divider2 = _interopRequireDefault(_Divider);

var _WithError = require('./WithError');

var _WithError2 = _interopRequireDefault(_WithError);

var _reduxForm = require('./utility/redux-form');

var _focus = require('./utility/focus');

var _dom = require('./utility/dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// `PureComponent` is only available in React >= 15.3.0.
var PureComponent = _react2.default.PureComponent || _react2.default.Component;

var empty_value_option_value = '';

var Select = (0, _reactLifecyclesCompat.polyfill)(_class = (_temp2 = _class2 = function (_PureComponent) {
	_inherits(Select, _PureComponent);

	function Select() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Select);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.focus = function () {
			return _this.select.focus();
		}, _this.focusToggler = function () {
			return _this.selectButton.focus();
		}, _this.onCollapse = function (_ref2) {
			var focusOut = _ref2.focusOut;

			_this.setState({ isExpanded: false });

			if (!focusOut) {
				if (_this.isUsingKeyboard) {
					_this.focus();
				} else {
					_this.focusToggler();
				}
			}
		}, _this.onExpand = function () {
			return _this.setState({ isExpanded: true });
		}, _this.expand = function () {
			return _this.list.expand();
		}, _this.collapse = function () {
			return _this.list.collapse();
		}, _this.toggle = function () {
			return _this.list.toggle();
		}, _this.storeListRef = function (ref) {
			return _this.list = ref;
		}, _this.storeSelectNode = function (node) {
			return _this.select = node;
		}, _this.storeSelectButton = function (node) {
			return _this.selectButton = node;
		}, _this.storeInputComponentNode = function (node) {
			return _this.inputComponentNode = node;
		}, _this.storeContainerNode = function (node) {
			return _this.container = node;
		}, _this.getSelectButton = function () {
			return _this.selectButton;
		}, _this.nativeSelectOnKeyDown = function (event) {
			_this.isUsingKeyboard = true;

			if (_this.shouldShowOptionsList()) {
				// Native select is the main focusable element now
				// even when the custom select is rendered.
				// this.focusToggler()
				_this.onKeyDownFromNativeSelect = true;
				_this.onKeyDown(event);
			}
		}, _this.nativeSelectOnMouseDown = function (event) {
			if (_this.shouldShowOptionsList()) {
				event.preventDefault();
				// Native select is the main focusable element now
				// even when the custom select is rendered.
				// this.focusToggler()
				_this.toggle();
			}
		}, _this.nativeSelectOnChange = function (event) {
			var _this$props = _this.props,
			    native = _this$props.native,
			    nativeExpanded = _this$props.nativeExpanded;


			var value = event.target.value;

			// Convert back from an empty string to `undefined`
			if (value === empty_value_option_value) {
				// `null` is not accounted for, use `undefined` instead.
				value = undefined;
			}

			_this.setValue(value);

			// Firefox has a bug:
			// Spacebar key on native `<select/>` is not being "preventDefault"ed.
			// https://bugzilla.mozilla.org/show_bug.cgi?id=1428992
			// https://bugzilla.mozilla.org/show_bug.cgi?id=1019630
			// https://stackoverflow.com/questions/15141398/cannot-preventdefault-via-firefox-on-a-select
			// This workaround hides the custom `<Select/>`
			// when a user selects something in the native `<select/>`
			// which expands over the custom one in Firefox due to the bug.
			if (navigator.userAgent.toLowerCase().indexOf('firefox') >= 0) {
				if (!native && !nativeExpanded) {
					_this.collapse();
				}
			}
		}, _this.onClick = function (event) {
			var _this$props2 = _this.props,
			    disabled = _this$props2.disabled,
			    nativeExpanded = _this$props2.nativeExpanded;


			if (!disabled) {
				_this.toggle();
			}
		}, _this.onKeyDown = function (event) {
			var _this$props3 = _this.props,
			    disabled = _this$props3.disabled,
			    value = _this$props3.value,
			    required = _this$props3.required;
			var isExpanded = _this.state.isExpanded;

			// Reset "event came from native select" flag.

			var fromNativeSelect = _this.onKeyDownFromNativeSelect;
			_this.onKeyDownFromNativeSelect = false;

			if (disabled) {
				return;
			}

			if (event.defaultPrevented) {
				return;
			}

			if (!isExpanded) {
				if ((0, _dom.submitFormOnCtrlEnter)(event, _this.selectButton)) {
					return;
				}
			}

			if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
				return;
			}

			switch (event.keyCode) {
				// "Up" arrow.
				// Select the previous item (if present).
				case 38:
				// "Down" arrow.
				// Select the next item (if present).
				case 40:
					// Firefox has a bug:
					// Up/Down arrow keys on native `<select/>` are not being "preventDefault"ed.
					// https://bugzilla.mozilla.org/show_bug.cgi?id=1428992
					// https://bugzilla.mozilla.org/show_bug.cgi?id=1019630
					// https://stackoverflow.com/questions/15141398/cannot-preventdefault-via-firefox-on-a-select
					// This workaround doesn't expand the custom `<Select/>`
					// when a user presses an Up/Down arrow key on the native `<select/>`.
					if (navigator.userAgent.toLowerCase().indexOf('firefox') >= 0) {
						return;
					}
					return _this.list.onKeyDown(event);

				// "Enter".
				case 13:
					// Submit containing `<form/>`.
					// Expand otherwise.
					if (required && isEmptyValue(value) || !(0, _dom.submitContainingForm)(_this.selectButton)) {
						_this.expand();
					}
					return event.preventDefault();

				// "Spacebar".
				case 32:
					if (fromNativeSelect) {
						// Firefox has a bug:
						// Spacebar key on native `<select/>` is not being "preventDefault"ed.
						// https://bugzilla.mozilla.org/show_bug.cgi?id=1428992
						// https://bugzilla.mozilla.org/show_bug.cgi?id=1019630
						// https://stackoverflow.com/questions/15141398/cannot-preventdefault-via-firefox-on-a-select
						event.preventDefault();

						_this.expand();
					}
					return;
			}
		}, _this.setValue = function (newValue) {
			var _this$props4 = _this.props,
			    value = _this$props4.value,
			    onChange = _this$props4.onChange;

			// Call `onChange` only if the `value` did change.

			if (newValue !== value) {
				onChange(newValue);
			}
		}, _this.onBlur = function (event) {
			clearTimeout(_this.blurTimer);
			_this.blurTimer = (0, _focus.onBlur)(event, _this.onFocusOut, function () {
				return _this.container;
			});
		}, _this.onFocusOut = function (event) {
			var _this$props5 = _this.props,
			    native = _this$props5.native,
			    nativeExpanded = _this$props5.nativeExpanded,
			    onBlur = _this$props5.onBlur,
			    value = _this$props5.value;


			if (!native && !nativeExpanded) {
				// `window.rruiCollapseOnFocusOut` can be used
				// for debugging expandable contents.
				if (window.rruiCollapseOnFocusOut !== false) {
					_this.collapse();
				}
			}

			// // Collapse the options `<List/>` if it's expanded.
			// if (this.list) {
			// 	this.list.onBlur(event)
			// }

			_this._onFocusOut();

			if (onBlur) {
				(0, _reduxForm.onBlurForReduxForm)(onBlur, event, value);
			}
		}, _this.onFocusIn = function () {
			return _this.setState({ isFocused: true });
		}, _this._onFocusOut = function () {
			return _this.setState({ isFocused: false });
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	// On mobile devices the <button/> is focused instead of <select/>
	// because when <select/> is focused then native mobile <select/> is expanded.


	_createClass(Select, [{
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			clearTimeout(this.blurTimer);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    upward = _props.upward,
			    icon = _props.icon,
			    compact = _props.compact,
			    scroll = _props.scroll,
			    scrollMaxItems = _props.scrollMaxItems,
			    scrollIntoView = _props.scrollIntoView,
			    alignment = _props.alignment,
			    saveOnIcons = _props.saveOnIcons,
			    native = _props.native,
			    disabled = _props.disabled,
			    required = _props.required,
			    placeholder = _props.placeholder,
			    options = _props.options,
			    value = _props.value,
			    onChange = _props.onChange,
			    indicateInvalid = _props.indicateInvalid,
			    error = _props.error,
			    closeButtonIcon = _props.closeButtonIcon,
			    closeLabel = _props.closeLabel,
			    optionComponent = _props.optionComponent,
			    selectedOptionComponent = _props.selectedOptionComponent,
			    wait = _props.wait,
			    style = _props.style,
			    className = _props.className;
			var _state = this.state,
			    isExpanded = _state.isExpanded,
			    isFocused = _state.isFocused;


			var topLabel = this.getTopLabel();

			return _react2.default.createElement(
				_WithError2.default,
				{
					setRef: this.storeContainerNode,
					error: error,
					indicateInvalid: indicateInvalid,
					style: style,
					className: (0, _classnames2.default)(className, 'rrui__select', {
						'rrui__select--compact': compact || icon,
						'rrui__select--focus': isFocused
					}) },
				_react2.default.createElement(
					'div',
					{
						ref: this.storeInputComponentNode,
						style: selectedOptionComponent && DISPLAY_FLEX,
						className: selectedOptionComponent ? undefined : 'rrui__input' },
					wait && _react2.default.createElement(_Ellipsis2.default, null),
					this.renderNativeSelect(),
					!native && this.renderSelectButton(),
					topLabel && _react2.default.createElement(
						_TextInputLabel2.default,
						{
							'aria-hidden': true,
							value: value,
							required: required,
							invalid: indicateInvalid && error,
							floats: false },
						topLabel
					),
					this.shouldShowOptionsList() && _react2.default.createElement(
						_ExpandableList2.default,
						{
							ref: this.storeListRef,
							'aria-label': this.getAriaLabel(),
							'aria-required': required && isEmptyValue(value) ? true : undefined,
							'aria-invalid': error && indicateInvalid ? true : undefined,
							upward: upward,
							alignment: alignment,
							scrollIntoView: scrollIntoView,
							scrollMaxItems: scroll === false ? 0 : scrollMaxItems,
							tabbable: false,
							value: value,
							onChange: this.setValue,
							onCollapse: this.onCollapse,
							onExpand: this.onExpand,
							getTogglerNode: this.getSelectButton,
							onFocusIn: this.onFocusIn,
							onFocusOut: this.onFocusOut,
							closeButtonIcon: closeButtonIcon,
							closeLabel: closeLabel,
							className: (0, _classnames2.default)('rrui__shadow', 'rrui__options-list', {
								'rrui__options-list--left-aligned': alignment === 'left',
								'rrui__options-list--right-aligned': alignment === 'right'
							}) },
						options.map(function (option, i) {
							return _react2.default.createElement(
								_List2.default.Item,
								{
									key: i,
									value: option.value,
									icon: option.divider || saveOnIcons ? undefined : option.icon,
									component: option.divider ? undefined : optionComponent,
									item: option.divider ? undefined : optionComponent ? option : undefined },
								option.divider ? _react2.default.createElement(_Divider2.default, null) : optionComponent ? undefined : option.content ? option.content(option) : option.label
							);
						})
					)
				)
			);
		}
	}, {
		key: 'renderSelectButton',
		value: function renderSelectButton() {
			var _props2 = this.props,
			    wait = _props2.wait,
			    value = _props2.value,
			    disabled = _props2.disabled,
			    required = _props2.required,
			    icon = _props2.icon,
			    title = _props2.title,
			    native = _props2.native,
			    nativeExpanded = _props2.nativeExpanded,
			    toggleClassName = _props2.toggleClassName,
			    selectedOptionClassName = _props2.selectedOptionClassName,
			    selectedOptionInvalidClassName = _props2.selectedOptionInvalidClassName,
			    selectedOptionDisabledClassName = _props2.selectedOptionDisabledClassName,
			    indicateInvalid = _props2.indicateInvalid,
			    error = _props2.error,
			    SelectedOptionComponent = _props2.selectedOptionComponent;
			var isExpanded = this.state.isExpanded;


			var selected = this.getSelectedOption();

			var selectedOptionLabel = selected && selected.label || this.getPlaceholder();
			var showIconOnly = icon && selected && selected.icon;

			// ARIA (accessibility) roles info:
			// https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
			//
			// `aria-haspopup`:
			// https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
			// WAI-ARIA 1.1 is not yet supported, so not using `aria-haspopup="listbox"`.

			// This button could be focusable in case of !native && !nativeExpanded.
			// In case of nativeExpanded if this button was focusable then the user would
			// tab to the button and press Spacebar key and there would be no way to
			// expand the native select so the keyboard user would be stuck.
			// Because of this, this button is never tabbable and native select always is.

			return _react2.default.createElement(
				'button',
				{
					ref: this.storeSelectButton,
					type: 'button',
					disabled: disabled,
					onClick: this.onClick,
					onKeyDown: this.onKeyDown,
					onFocus: this.onFocusIn,
					onBlur: this.onBlur,
					tabIndex: -1,
					title: title,
					'aria-label': this.getAriaLabel() || (showIconOnly ? selectedOptionLabel : undefined),
					'aria-expanded': isExpanded ? true : false,
					className: (0, _classnames2.default)('rrui__button-reset', 'rrui__outline', 'rrui__select__button', toggleClassName, selectedOptionClassName, selectedOptionInvalidClassName && SelectedOptionComponent && indicateInvalid && error, selectedOptionDisabledClassName && SelectedOptionComponent && disabled, {
						'rrui__input-element': !SelectedOptionComponent,
						'rrui__select__button--empty': !SelectedOptionComponent && isEmptyValue(value) && !this.hasEmptyOption(),
						'rrui__select__button--invalid': !SelectedOptionComponent && indicateInvalid && error,
						'rrui__select__button--disabled': !SelectedOptionComponent && disabled
					}) },
				SelectedOptionComponent ? _react2.default.createElement(SelectedOptionComponent, _extends({
					wait: wait
				}, selected)) : _react2.default.createElement(DefaultSelectedOptionComponent, {
					indicateRequired: !this.getTopLabel() && required && isEmptyValue(value),
					wait: wait,
					value: value,
					label: selectedOptionLabel,
					icon: showIconOnly ? _react2.default.createElement(selected.icon, { value: value, label: selectedOptionLabel }) : undefined })
			);
		}
	}, {
		key: 'renderNativeSelect',
		value: function renderNativeSelect() {
			var _props3 = this.props,
			    name = _props3.name,
			    value = _props3.value,
			    label = _props3.label,
			    disabled = _props3.disabled,
			    required = _props3.required,
			    native = _props3.native,
			    nativeExpanded = _props3.nativeExpanded,
			    error = _props3.error,
			    indicateInvalid = _props3.indicateInvalid,
			    tabIndex = _props3.tabIndex;


			return _react2.default.createElement(
				'select',
				{
					ref: this.storeSelectNode,
					name: name,
					value: isEmptyValue(value) ? empty_value_option_value : value,
					disabled: disabled,
					onKeyDown: this.nativeSelectOnKeyDown,
					onMouseDown: this.nativeSelectOnMouseDown,
					onChange: this.nativeSelectOnChange,
					onFocus: this.onFocusIn,
					onBlur: this.onBlur,
					tabIndex: tabIndex,
					'aria-label': this.getAriaLabel(),
					'aria-required': required && isEmptyValue(value) ? true : undefined,
					'aria-invalid': error && indicateInvalid ? true : undefined,
					className: (0, _classnames2.default)(
					// `:focus` style is implemented via border color
					// so outline can be muted safely here.
					'rrui__outline', 'rrui__select__native', {
						'rrui__select__native--overlay': !native,
						'rrui__select__native--invalid': indicateInvalid && error
					}) },
				this.renderNativeSelectOptions()
			);
		}
	}, {
		key: 'renderNativeSelectOptions',
		value: function renderNativeSelectOptions() {
			var _this2 = this;

			var _props4 = this.props,
			    options = _props4.options,
			    value = _props4.value,
			    placeholder = _props4.placeholder;


			var empty_option_present = false;

			var rendered_options = options.map(function (option, i) {
				var value = option.value,
				    label = option.label,
				    divider = option.divider;


				if (!divider && isEmptyValue(value)) {
					empty_option_present = true;
					value = empty_value_option_value;
				}

				return _this2.renderNativeSelectOption(i, value, label, divider === true, divider);
			});

			if (isEmptyValue(value) && !empty_option_present) {
				rendered_options.unshift(this.renderNativeSelectOption(-1, undefined, placeholder, true));
			}

			return rendered_options;
		}
	}, {
		key: 'renderNativeSelectOption',
		value: function renderNativeSelectOption(key, value, label, nonSelectable, isDivider) {
			return _react2.default.createElement(
				'option',
				{
					key: key,
					value: isEmptyValue(value) ? '' : value,
					hidden: nonSelectable && !isDivider ? true : undefined,
					disabled: nonSelectable ? true : undefined,
					className: (0, _classnames2.default)('rrui__select__native-option', {
						'rrui__select__native-option--divider': isDivider
					}) },
				label
			);
		}
	}, {
		key: 'hasEmptyOption',
		value: function hasEmptyOption() {
			var options = this.props.options;


			for (var _iterator = options, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
				var _ref3;

				if (_isArray) {
					if (_i >= _iterator.length) break;
					_ref3 = _iterator[_i++];
				} else {
					_i = _iterator.next();
					if (_i.done) break;
					_ref3 = _i.value;
				}

				var option = _ref3;

				if (!option.divider && isEmptyValue(option.value)) {
					return true;
				}
			}

			return false;
		}
	}, {
		key: 'getSelectedOption',
		value: function getSelectedOption() {
			var _props5 = this.props,
			    options = _props5.options,
			    value = _props5.value;


			for (var _iterator2 = options, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
				var _ref4;

				if (_isArray2) {
					if (_i2 >= _iterator2.length) break;
					_ref4 = _iterator2[_i2++];
				} else {
					_i2 = _iterator2.next();
					if (_i2.done) break;
					_ref4 = _i2.value;
				}

				var option = _ref4;

				if (!option.divider && option.value === value) {
					return option;
				}
			}
		}
	}, {
		key: 'getAriaLabel',
		value: function getAriaLabel() {
			var _props6 = this.props,
			    ariaLabel = _props6.ariaLabel,
			    label = _props6.label;


			return this.props['aria-label'] || ariaLabel || label;
		}
	}, {
		key: 'getTopLabel',
		value: function getTopLabel() {
			var _props7 = this.props,
			    label = _props7.label,
			    placeholder = _props7.placeholder,
			    value = _props7.value;


			if (isEmptyValue(value) && !placeholder) {
				// Label will be shown in placeholder's place
				// so don't show it as a label to prevent duplication.
				return;
			}

			return label;
		}
	}, {
		key: 'getPlaceholder',
		value: function getPlaceholder() {
			var _props8 = this.props,
			    label = _props8.label,
			    placeholder = _props8.placeholder,
			    value = _props8.value;


			if (isEmptyValue(value)) {
				return placeholder || label;
			}
		}
	}, {
		key: 'shouldShowOptionsList',
		value: function shouldShowOptionsList() {
			var _props9 = this.props,
			    native = _props9.native,
			    nativeExpanded = _props9.nativeExpanded;

			return !native && !nativeExpanded;
		}
	}]);

	return Select;
}(PureComponent), _class2.propTypes = {
	// A list of selectable options
	options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
		// Option value (may be `undefined`)
		value: _propTypes2.default.any,
		// Could restrict it to stringifiable types
		// but I guess this is not required
		// and one could even use `object`s as `value`s.
		// // Option value (may be `undefined`)
		// value : PropTypes.oneOfType([
		// 	PropTypes.string,
		// 	PropTypes.number,
		// 	PropTypes.bool
		// ]),
		// Option label (may be `undefined`)
		label: _propTypes2.default.string,
		// Option icon
		icon: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
		// (deprecated, use `optionComponent` instead)
		// Render custom content (a React component).
		// Receives `{ value, label }` properties.
		content: _propTypes2.default.func
	})).isRequired,

	// HTML form input `name` attribute
	name: _propTypes2.default.string,

	// Label which is placed above the select
	label: _propTypes2.default.string,

	// Placeholder (like "Choose")
	placeholder: _propTypes2.default.string,

	// Selected option component.
	// (when `<Select/>` is not expanded).
	// Receives properties:
	// `{ ...option }` — All properties of the selected `option` such as `value`, `label`, etc. Each `option` must have a `value` and a `label` (`value` may be `undefined`).
	// `wait` — Passed through `wait` property of the `<Select/>` component. `<Autocomplete/>` renders a `<Select/>` internally and passes `wait={true}` when it's loading options.
	// Can only contain "inline" elements like `<span/>`,
	// not `<div/>`s, `<section/`>s, `<h1/>`s or `<p/>`s,
	// because `<button/>`s can't contain "block" elements.
	// `display: block` can still be set on `<span/>`s and other "inline" elements.
	selectedOptionComponent: _propTypes2.default.elementType,

	// Option component.
	// (when `<Select/>` is expanded).
	// Receives properties:
	// * `{ ...option }` — All properties of an `option` such as `value`, `label`, etc. Each `option` must have a `value` and a `label` (`value` may be `undefined`).
	// * `selected: boolean` — If this option is selected.
	// * `focused: boolean` — If this option is focused.
	// * `disabled: boolean` — If this option is disabled. Seems to be not used for now.
	// Can only contain "inline" elements like `<span/>`,
	// not `<div/>`s, `<section/`>s, `<h1/>`s or `<p/>`s,
	// because `<button/>`s can't contain "block" elements.
	// `display: block` can still be set on `<span/>`s and other "inline" elements.
	optionComponent: _propTypes2.default.elementType,

	// Options list alignment.
	// Is "left" by default.
	alignment: _propTypes2.default.string,

	// Whether to use native `<select/>`
	native: _propTypes2.default.bool.isRequired,

	// Whether to use native `<select/>` when expanded
	nativeExpanded: _propTypes2.default.bool.isRequired,

	// Show icon only for selected item,
	// and only if `icon` is `true`.
	saveOnIcons: _propTypes2.default.bool.isRequired,

	// Disables this control
	disabled: _propTypes2.default.bool,

	// Set to `true` to mark the field as required
	required: _propTypes2.default.bool.isRequired,

	// Set to `true` to display the loading indicator
	wait: _propTypes2.default.bool.isRequired,

	// Selected option value
	value: _propTypes2.default.any,

	// Is called when an option is selected
	onChange: _propTypes2.default.func,

	// Is called when the select is blurred.
	// This `onBlur` interceptor is a workaround for `redux-form`,
	// so that it gets the parsed `value` in its `onBlur` handler,
	// not the formatted text.
	onBlur: _propTypes2.default.func,

	// If `scroll` is `false`, then options list
	// is not limited in height.
	// Is `true` by default (scrollable).
	scroll: _propTypes2.default.bool.isRequired,

	// Component CSS class
	className: _propTypes2.default.string,

	// `<button/>` toggler CSS class
	// (deprecated name, use `selectedOptionClassName` property name instead)
	toggleClassName: _propTypes2.default.string,

	// Selected option `<button/>` CSS class.
	selectedOptionClassName: _propTypes2.default.string,

	// Selected option `<button/>` CSS class when `error` property is passed.
	selectedOptionInvalidClassName: _propTypes2.default.string,

	// Selected option `<button/>` CSS class when `disabled` property is passed.
	selectedOptionDisabledClassName: _propTypes2.default.string,

	// CSS style object
	style: _propTypes2.default.object,

	// If this flag is set to `true`,
	// and `icon` is specified for a selected option,
	// then the selected option will be displayed
	// as icon only, without the label.
	icon: _propTypes2.default.bool,

	// If this flag is set to `true`,
	// then it makes `<Select/>` not stretch itself
	// to 100% width by making it `inline-block`.
	// Is set to `true` when `icon` is `true`
	// because it makes sense.
	compact: _propTypes2.default.bool,

	// HTML `tabindex` attribute
	tabIndex: _propTypes2.default.number,

	// `aria-label` for the `<Select/>`'s `<button/>`.
	// Deprecated, use `aria-label` instead.
	ariaLabel: _propTypes2.default.string
}, _class2.defaultProps = {
	native: false,
	nativeExpanded: false,

	saveOnIcons: false,

	// Set to `true` to mark the field as required
	required: false,

	// Show `error` (if passed).
	indicateInvalid: true,

	// Set to `true` to display the loading indicator
	wait: false,

	// Will show scrollbar on overflow.
	scroll: true,

	alignment: 'left'
}, _temp2)) || _class;

// Using indexes instead for keys.
// // There can be an `undefined` value,
// // so just `{ value }` won't do here.
// function getOptionKey(value) {
// 	return isEmptyValue(value) ? '@@rrui/empty' : value
// }

exports.default = Select;
function isEmptyValue(value) {
	return value === null || value === undefined;
}

function DefaultSelectedOptionComponent(_ref5) {
	var value = _ref5.value,
	    label = _ref5.label,
	    icon = _ref5.icon,
	    indicateRequired = _ref5.indicateRequired,
	    wait = _ref5.wait;

	// The `<span/>` wrapper is required for vertical centering.
	// http://stackoverflow.com/questions/35464067/flexbox-not-working-on-button-element-in-some-browsers
	return _react2.default.createElement(
		'span',
		{ className: 'rrui__select__selected-content' },
		_react2.default.createElement(
			'span',
			{
				className: (0, _classnames2.default)('rrui__select__selected-label', 'rrui__text-line', {
					'rrui__select__selected-label--required': indicateRequired
				}) },
			icon || label
		),
		!wait && _react2.default.createElement('span', { className: 'rrui__select__arrow' })
	);
}

DefaultSelectedOptionComponent.propTypes = {
	value: _propTypes2.default.any,
	label: _propTypes2.default.string,
	icon: _propTypes2.default.node,
	indicateRequired: _propTypes2.default.bool,
	wait: _propTypes2.default.bool

	/* `display: flex` fixes the incorrect toggler `<button/>` height
    in cases when custom `selectedOptionComponent` is used.
    It also removes the requirement for the `selectedOptionComponent`
    containing `<span/>` to be `display: block`. */
};var DISPLAY_FLEX = {
	display: 'flex'
};
//# sourceMappingURL=Select.js.map